<template>
  <div>
    <Modal :styles="{ top: '20px', zIndex: 1 }" :value="true" title="User Modal" :closable="false" :mask-closable="false">
      <div slot="header" class="d-flex justify-content-between align-items-center">
        <h5>{{ $t('club.add_club') }}</h5>
        <Button @click="close()" type="text" icon="md-close" class="modal-close-btn"></Button>
      </div>
      <Spin v-if="loading" fix>
        <Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
        <div>{{ $t("global.loading") }}</div>
      </Spin>
      <Form class="add-form-modal" ref="addFormModal" :label-width="130" :model="formValidate" :rules="ruleValidate">
        <FormItem :label="$t('club.logo')" prop="userFile">
          <div class="d-flex justify-content-between align-items-center">
            <div v-if="formValidate.logo" style="display: inherit">
              <div style="position: relative">
                <a @contextmenu.prevent="handler" :href="api_domain + formValidate.logo" class="mr-1"
                  style="display: inline-block" target="_blank">
                  <Avatar :src="api_domain + formValidate.logo" />
                </a>
              </div>
            </div>
            <Upload multiple ref="upload" :show-upload-list="false" :on-success="handleSuccess"
              :format="['jpg', 'jpeg', 'png', 'pdf']" :max-size="12048" :on-format-error="handleFormatError"
              :action="api_domain + 'file/upload'">
              <Button class="upload-file-btn" shape="circle" icon="ios-cloud-upload-outline"></Button>
            </Upload>
          </div>
        </FormItem>
        <FormItem :label="$t('club.form.name')" prop="name">
          <Input v-model="formValidate.name" :placeholder="$t('club.form.name')" type="text" />
        </FormItem>
        <FormItem :label="$t('club.form.fullname')" prop="fullName">
          <Input v-model="formValidate.fullName" :placeholder="$t('club.form.fullname')" type="text" />
        </FormItem>
        <FormItem :label="$t('club.form.president')" prop="president">
          <Input v-model="formValidate.president" :placeholder="$t('club.form.president')" type="text" />
        </FormItem>
        <FormItem :label="$t('club.form.responsible')" prop="responsible">
          <Input v-model="formValidate.responsible" :placeholder="$t('club.form.responsible')" type="text" />
        </FormItem>
        <FormItem :label="$t('club.form.phone')" prop="phone">
          <Input v-model="formValidate.phone" :placeholder="$t('club.form.phone')" type="text" />
        </FormItem>
        <FormItem :label="$t('club.form.email')" prop="email">
          <Input v-model="formValidate.email" :placeholder="$t('club.form.email')" type="text" />
        </FormItem>
        <FormItem :label="$t('club.form.province')" prop="province">
          <Select v-model="formValidate.province" name="province" :placeholder="$t('club.form.province')" filterable>
            <Option v-for="item in provinces" :value="item" :key="item">{{ item }}</Option>
          </Select>
        </FormItem>
        <FormItem :label="$t('club.form.town')" prop="town">
          <Select v-model="formValidate.town" name="town" :placeholder="$t('club.form.town')" filterable>
            <Option v-for="item in cities" :value="item" :key="item">{{ item }}</Option>
          </Select>
        </FormItem>
        <FormItem label="IDNO" prop="idno">
          <Input v-model="formValidate.idno" placeholder="IDNO..." type="text" />
        </FormItem>
        <FormItem :label="$t('competition.notes')" prop="notes">
          <Input v-model="formValidate.notes" placeholder="NOTE..." type="textarea" />
        </FormItem>

      </Form>
      <div slot="footer" class="text-center">
        <ButtonGroup class="modal-footer-btn">
          <Button @click="handleSubmit('addFormModal')" :loading="loading" type="success"><b>{{ $t('global.save')
          }}</b></Button>
        </ButtonGroup>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props: [
    'club'
  ],
  data() {
    return {
      serverError: '',
      loading: false,
      deleteFileIndex: null,
      cities: ['Bălți', 'Biruința', 'Briceni', 'Costești', 'Cupcini', 'Dondușeni', 'Drochia', 'Edineț', 'Fălești', 'Florești', 'Frunză', 'Ghindești', 'Glodeni', 'Lipcani', 'Mărculești', 'Ocnița', 'Otaci', 'Rîșcani', 'Sîngerei', 'Soroca', 'Anenii Noi', 'Bucovăț', 'Căinari', 'Călărași', 'Căușeni', 'Cornești', 'Criuleni', 'Hîncești', 'Ialoveni', 'Nisporeni', 'Orhei', 'Rezina', 'Strășeni', 'Șoldănești', 'Ștefan Vodă', 'Telenești', 'Tighina (Bender)', 'Ungheni', 'Chișinău', 'Codru', 'Cricova', 'Durlești', 'Sîngera', 'Vadul lui Vodă', 'Vatra', 'Basarabeasca', 'Cantemir', 'Cahul', 'Cimișlia', 'Iargara', 'Leova', 'Taraclia', 'Tvardița', 'Camenca', 'Crasnoe', 'Dnestrovsc', 'Dubăsari', 'Grigoriopol', 'Rîbnița', 'Maiac', 'Slobozia', 'Tiraspol', 'Tiraspolul Nou', 'Ceadîr-Lunga', 'Comrat', 'Vulcănești'],
      provinces: ['Municipiul Chișinău', 'Municipiul Bălți', 'Municipiul Bender', 'Municipiul Comrat', 'Municipiul Tiraspol', 'Municipiul Cahul', 'Municipiul Ceadîr-Lunga', 'Municipiul Edineț', 'Municipiul Hîncești', 'Municipiul Orhei', 'Municipiul Soroca', 'Municipiul Strășeni', 'Municipiul Ungheni', 'Raionul Basarabeasca', 'Raionul Briceni', 'Raionul Glodeni', 'Raionul Dondușeni', 'Raionul Drochia', 'Raionul Dubăsari', 'Raionul Edineț', 'Raionul Cahul', 'Raionul Călărași', 'Raionul Cantemir', 'Raionul Căușeni', 'Raionul Criuleni', 'Raionul Leova', 'Raionul Nisporeni', 'Raionul Anenii Noi', 'Raionul Ocnița', 'Raionul Orhei', 'Raionul Rezina', 'Raionul Rîșcan', 'Raionul Soroca', 'Raionul Strășeni', 'Raionul Sîngerei', 'Raionul Taraclia', 'Raionul Telenești', 'Raionul Ungheni', 'Raionul Fălești', 'Raionul Florești', 'Raionul Hîncești', 'Raionul Cimișlia', 'Raionul Șoldănești', 'Raionul Ștefan-Vodă', 'Raionul Ialoveni', 'Unitatea Teritorială Autonomă Găgăuzia', 'Unitățile Administrativ-Teritoriale din Stînga Nistrului'],
      formValidate: {
        logo: '',
        name: '',
        fullName: '',
        president: '',
        responsible: '',
        phone: '',
        email: '',
        province: '',
        town: '',
        idno: '',
        notes: ''
      },
      ruleValidate: {
        name: [
          { required: true, message: 'The name cannot be empty', trigger: 'blur' }
        ],
        fullName: [
          { required: true, message: 'The name cannot be empty', trigger: 'blur' }
        ],
        president: [
          { required: true, message: 'The name cannot be empty', trigger: 'blur' }
        ],
        responsible: [
          { required: true, message: 'The name cannot be empty', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: 'The name cannot be empty', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Mailbox cannot be empty', trigger: 'blur' },
          { type: 'email', message: 'Incorrect email format', trigger: 'blur' }
        ],
        province: [
          { required: true, message: 'The name cannot be empty', trigger: 'blur' }
        ],
        town: [
          { required: true, message: 'The name cannot be empty', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    formValidate: {
      deep: true,
      handler(_n) {
        this.changes = true
      }
    }
  },
  methods: {
    close() {
      if (this.changes === true) {
        this.$dialog
          .confirm(
            this.$t('global.nonSaveConfirm'),
            {
              okText: this.$t("global.yes"),
              cancelText: this.$t("global.no"),
              html: true,
              customClass: 'mahnung-confirm',
            }
          ).then(async (_dialog) => {
            this.$emit('close', 0)
          }).catch((error) => {
            console.log(error);
          });
      } else { this.$emit('close', 0) }
    },
    handleReset(name) {
      this.$refs[name].resetFields()
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: 'The file format is incorrect',
        desc:
          'File format of ' +
          file.name +
          ' is incorrect, please select jpg or png.'
      })
    },
    handleSuccess(res, file) {
      this.formValidate['logo'] = res.path
    },
    handleSubmit(name) {
      this.loading = true
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          this.loading = true
          await this.submitForm()
          // setTimeout(() => {
          //   this.$emit('close')
          // }, 700)
          this.loading = false
        } else {
          this.$Message.error('Fail!')
          this.loading = false
        }
      })
    },
    clearForm() {
      this.serverError = ''
      this.loading = false
      this.deleteFileIndex = null
      this.formValidate.logo = ''
      this.formValidate.name = ''
      this.formValidate.fullName = ''
      this.formValidate.president = ''
      this.formValidate.responsible = ''
      this.formValidate.phone = ''
      this.formValidate.email = ''
      this.formValidate.province = ''
      this.formValidate.town = ''
      this.formValidate.idno = ''
      this.formValidate.notes = ''
    },
    async submitForm() {
      this.loading = true
      this.serverError = ''
      let type = 'addNew'
      if (this.club) type = 'editNew'
      try {
        let response = await this.$http.post('/club/' + type, {
          clubData: this.formValidate
        })
        if (response.status === 201) {
          if (!this.club) this.$refs['addFormModal'].resetFields()
          if (!this.club)
            this.clearForm()
          this.loading = false
          this.$emit('updateList', 0)
          this.$Message.success('Success!')
          this.$emit('close', 0)
        }
      } catch (e) {
        console.log(e)
        this.loading = false
        console.log(e.response.data)
        this.serverError = e.response.data.codes[0]
      }
    }
  },
  async mounted() {
    if (this.club !== null) {
      const val = JSON.parse(JSON.stringify(this.club))
      let obj = {
        ...this.formValidate,
        ...val
      }
      this.formValidate = { ...obj }
      setTimeout(() => { this.changes = false }, 0)
    }
  }
}

</script>
<style scoped>
.add-form-modal :global(.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus) {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.add-form-modal :global(.ivu-radio-group-button .ivu-radio-wrapper-checked),
.add-form-modal :global(.ivu-radio-group-button .ivu-radio-wrapper-checked:first-child) {
  border-color: transparent !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.add-form-modal :global(.ivu-radio-group-button .ivu-radio-wrapper:after),
.add-form-modal :global(.ivu-radio-group-button .ivu-radio-wrapper:before) {
  content: none !important;
  background: transparent !important;
  display: none !important;
}

.add-form-modal :global(.ivu-form-item-error-tip) {
  padding-top: 2px;
}

.add-form-modal :global(.ivu-form-item) {
  margin-bottom: 10px;
}

.modal-close-btn {
  padding: 0 5px;
  font-size: 20px;
}

.upload-file-btn :global(.ivu-icon) {
  color: #3399ff;
  font-weight: bold;
}

.add-form-modal :global(.ivu-form-item) {
  margin-bottom: 10px;
}

.add-form-modal :global(.ivu-form-item-label) {
  padding: 5px 12px 5px 0;
  margin-bottom: 0;
}

div :global(.ivu-form-item-error-tip) {
  z-index: 100 !important;
  position: relative;
}

.add-form-modal :global(.ivu-card-head p) {
  font-size: 13px;
  color: #495057;
}
</style>



// WEBPACK FOOTER //
// src/components/club/ClubAddModal.vue